import { RefObject, useEffect } from 'react';

/** Maps vertical wheel movement to horizontal scroll on wide table containers. */
export function useHorizontalWheelScroll(
  containerRef: RefObject<HTMLElement | null>
) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const handleWheel = (event: WheelEvent) => {
      const canScrollHorizontally =
        container.scrollWidth > container.clientWidth;
      if (!canScrollHorizontally) {
        return;
      }

      const isPrimarilyVertical = Math.abs(event.deltaY) > Math.abs(event.deltaX);
      if (!isPrimarilyVertical) {
        return;
      }

      container.scrollLeft += event.deltaY;
      event.preventDefault();
    };

    container.addEventListener('wheel', handleWheel, { passive: false });

    return () => {
      container.removeEventListener('wheel', handleWheel);
    };
  }, [containerRef]);
}
